import type { PublicQuote } from "@forgepoint/shared";
import { QuoteDocumentRenderer } from "./QuoteDocumentRenderer";
import type { DocumentAssetUrls } from "./types";

interface QuoteDocumentPreviewProps {
  publicQuote: PublicQuote;
  assetUrls: DocumentAssetUrls;
  documentHtml: string;
}

/**
 * View-only scrollable render of the stored quote document. No editor hook,
 * toolbar, palette, properties panel, source drawer, or Save button is
 * mounted, so the document can be inspected but not mutated or saved.
 * @param publicQuote - The customer-safe quote projection bound into the canvas
 * @param assetUrls - Resolved signed asset urls keyed by asset id
 * @param documentHtml - The last-saved stored document HTML
 */
export function QuoteDocumentPreview({
  publicQuote,
  assetUrls,
  documentHtml,
}: QuoteDocumentPreviewProps) {
  return (
    <div className="relative flex-1 min-h-0 overflow-auto bg-muted">
      <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 motion-reduce:animate-none">
        <QuoteDocumentRenderer
          documentHtml={documentHtml}
          quote={publicQuote}
          assetUrls={assetUrls}
          mode="view"
        />
      </div>
    </div>
  );
}
